import { Badge } from '@/components/ui/badge';
import type { ListingStatus, StorePlatform } from '@/types/store';

import { PLATFORM_LABELS } from './store-constants';

export function PlatformBadge({ platform }: { platform: StorePlatform }): JSX.Element {
  return <Badge variant="outline">{PLATFORM_LABELS[platform]}</Badge>;
}

/** Draft (neutral) vs Published (green) — the listing/screenshot lifecycle. */
export function ListingStatusBadge({ status }: { status: ListingStatus }): JSX.Element {
  return status === 'published' ? (
    <Badge variant="active">Published</Badge>
  ) : (
    <Badge variant="idle">Draft</Badge>
  );
}
